export default function getProductImage(imageName: string) :string{
    let images: __WebpackModuleApi.RequireContext
    let result = '';
    try{
        images = require.context('../../public/assets/products/', false);
        result = images('./' + imageName);
    }catch{
        images = require.context('../../public/assets/', false);
        result = images('./image.webp');
    }
    if (!result.startsWith("data:image")) {
        result += '?version=' + process.env.VUE_APP_CACHE_BUSTING;
    }
    
    return result;
}
